import React from "react";

export default function ContactInfoAdminSection({
  lang,
  contactInfo,
  setContactInfo,
  saveContactInfo
}) {
  if (!contactInfo) return null;

  return (
    <section className="section">
      <h2 className="sectionTitle">Contact Info ({lang})</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <input
          name="email"
          value={contactInfo.email || ""}
          onChange={e => setContactInfo({ ...contactInfo, email: e.target.value })}
          placeholder="Email"
          className="input"
        />
        <input
          name="phone"
          value={contactInfo.phone || ""}
          onChange={e => setContactInfo({ ...contactInfo, phone: e.target.value })}
          placeholder="Teléfono"
          className="input"
        />
        <button
          onClick={saveContactInfo}
          className="button"
          style={{ alignSelf: "flex-start", marginTop: "0.5rem" }}
        >
          Guardar Contact Info
        </button>
      </div>
    </section>
  );
}